/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { isString } from 'lodash';

import { DisplayTextField } from '../DisplayTextField';

import { FormPreviewProps, SectionField } from './props';

export const FormPreview: React.FC<FormPreviewProps> = (props) => {
  const {
    previewSection = [],
    textFieldProps,
    fieldContainerProps,
    sectionContainerProps,
    previewHeaderTitleProps,
    previewHeaderContainerProps,
  } = props;
  const renderValue = (field: SectionField) => {
    const value = field?.value;
    if (isString(value))
      return (
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          {value}
        </Typography>
      );
    return value;
  };
  return (
    <React.Fragment>
      {previewSection?.map((list, i) => {
        if (!list) return null;
        return (
          <Box
            key={i}
            sx={{
              borderBottom: 1,
              borderColor: 'lightgrey',
            }}
            {...sectionContainerProps}
          >
            <Box
              sx={{ marginTop: list?.section_title ? 'unset' : '-20px' }}
              {...previewHeaderContainerProps}
            >
              {list?.section_title && (
                <Typography color={'text.primary'} {...previewHeaderTitleProps}>
                  {list?.section_title}
                </Typography>
              )}
              {list?.enableEdit ? (
                <IconButton {...list?.editButtonProps}>
                  <EditIcon />
                </IconButton>
              ) : null}
            </Box>
            <Grid
              container
              spacing={2}
              sx={{ rowGap: 3, marginTop: 3 }}
              direction="row"
              {...fieldContainerProps}
            >
              {list?.section_field?.map((field, i) => (
                <Grid
                  key={i}
                  item
                  md={field?.colspan ?? 12}
                  xs={field?.mobileColspan ?? 12}
                >
                  {field?.title ? (
                    <DisplayTextField
                      {...textFieldProps}
                      label={field?.title}
                      value={field?.value}
                      type={field?.type}
                    />
                  ) : (
                    <>{renderValue(field)}</>
                  )}
                </Grid>
              ))}
            </Grid>
          </Box>
        );
      })}
    </React.Fragment>
  );
};

export * from './props';
export default FormPreview;
